__turbopack_context__.v({
  "slider": "j6YGCa_slider",
});
